import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  IconButton,
  Rating,
  Slide,
  Snackbar,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar, useGridApiRef } from "@mui/x-data-grid";
import {
  useExtraLoraNotesMutation,
  useGetExtraLorasQuery,
  useDeleteExtraLorasMutation,
  useRateExtraLoraMutation,
  useAddExtraLoraMutation,
} from "api/apiSlice";
import FlexColumn from "components/Column";
import MediumDialog from "components/MediumDialog";
import FlexRow from "components/Row";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoadedPrompt, setSelectedFluxLoras } from "state/generate";
import Toast from "components/Toast";
import { Done, ExpandMore, PriorityHigh } from "@mui/icons-material";
import SmallDialog from "components/SmallDialog";
import ExtraLoraEditMenu from "./ExtraLoraMenu";

const ExtraLoraDialog = ({
  extraDialogOpen,
  setextraDialogOpen,
  setextraDialogData,
}) => {
  const apiRef = useGridApiRef();
  const { data, error, isLoading } = useGetExtraLorasQuery();
  const [toast, setToast] = useState({
    show: false,
    severity: "success",
    msg: "",
  });
  const dispatch = useDispatch();
  const [addExtraLora] = useAddExtraLoraMutation();
  const [deleteExtraLora] = useDeleteExtraLorasMutation();
  const loadedPrompt = useSelector((state) => state.generate.loadedPrompt);
  const selectedFluxLoras = useSelector(
    (state) => state.generate.selected_flux_loras
  );
  const extraLoras = useSelector((state) => state.generate.extraLoras);
  const [extraloraname, setextraloraname] = useState("");
  const [extraLorasList, setextraLorasList] = useState(
    loadedPrompt.extraLoras[`${loadedPrompt.species}_${loadedPrompt.gender}`]
  );

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState(false);
  const [loraExistsInfo, setloraExistsInfo] = useState();
  const [rows, setrows] = useState([]);
  const retypeNameRef = useRef(null);
  const [deleteLoraName, setDeleteLoraName] = useState("xsdxcxfcdfsddsx");
  const [deleteLoraNameConfirm, setDeleteLoraNameConfirm] = useState("");
  const [deleteConfirmData, setDeleteConfirmData] = useState(false);

  const [addNewLoraDialogOpen, setAddNewLoraDialogOpen] = useState(false);
  const [addNewLoraDialogData, setAddNewLoraDialogData] = useState(false);
  const [downloadingNewLora, setDownloadingNewLora] = useState(false);

  const [copyAcrossDialogOpen, setCopyAcrossDialogOpen] = useState(false);
  const [copyAcrossDialogData, setCopyAcrossDialogData] = useState(false);

  const newLoraIdRef = useRef(null);
  const newLoraNameRef = useRef(null);
  const newLoraDescriptionRef = useRef(null);

  const [selectedSpeciesGenders, setSelectedSpeciesGenders] = useState([
    { label: "human_male", value: "human_male", checked: false },
    { label: "human_female", value: "human_female", checked: false },
    { label: "cat_male", value: "cat_male", checked: false },
    { label: "cat_female", value: "cat_female", checked: false },
    { label: "dog_male", value: "dog_male", checked: false },
    { label: "dog_female", value: "dog_female", checked: false },
  ]);

  useEffect(() => {
    if (data) {
      const d = Object.keys(data.data).map((lora, index) => {
        return {
          name: lora,
          url: data.data[lora].url,
          description: data.data[lora].description,
          rate: data.data[lora].rate,
          image_url: data.data[lora].image_url,
          trigger_words: data.data[lora].trigger_words,
          strength: data.data[lora].strength,
          notes: data.data[lora].notes,
        };
      });
      setrows(d);
    }
  }, [data]);

  const handleAddDefaultExtraLora = () => {
    const defaultLoras = [
      { name: "flux_realism_lora", strength: 1 },
      {
        name: "araminta_k_flux_film_foto",

        strength: 1,
      },
      { name: "paradiffflux", strength: 1 },
    ];

    // setextraLorasList((current) => [...current, ...defaultLoras]);
    dispatch(
      setLoadedPrompt({
        key: ["extraLoras", `${loadedPrompt.species}_${loadedPrompt.gender}`],
        data: [
          ...loadedPrompt.extraLoras[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ],
          ...defaultLoras,
        ],
      })
    );
  };

  const handleSelectFluxLora = (index, selected, strength) => {
    var sel = JSON.parse(JSON.stringify(selectedFluxLoras));
    sel[index].selected = selected;
    sel[index].strength = strength;
    dispatch(setSelectedFluxLoras(sel));
    // dispatch(
    //   setSelectedFluxLoras(typeof value === 'string' ? value.split(',') : value)
    // );
  };

  const handleAddExtraLora = (lora) => {
    console.log(toast);
    const temp = { name: lora.name, strength: lora.strength };
    // setextraLorasList((current) => [...current, temp]);
    if (
      loadedPrompt.extraLoras[
        `${loadedPrompt.species}_${loadedPrompt.gender}`
      ].find((item) => item.name === lora.name)
    ) {
      setToast({
        show: true,
        severity: "error",
        msg: "Lora already added",
      });
      return;
    }
    dispatch(
      setLoadedPrompt({
        key: ["extraLoras", `${loadedPrompt.species}_${loadedPrompt.gender}`],
        data: [
          ...loadedPrompt.extraLoras[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ],
          lora,
        ],
      })
    );
    dispatch(
      setLoadedPrompt({
        key: ["prompts", `${loadedPrompt.species}_${loadedPrompt.gender}`],
        data:
          lora.trigger_words.join(", ") +
          "\n\n" +
          loadedPrompt.prompts[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ],
      })
    );
    setToast({
      show: true,
      severity: "success",
      msg: "Lora added",
    });
  };
  const handleRemoveExtraLora = async (name) => {
    // setextraLorasList((current) => [
    //   ...current.filter((item) => item.name !== name),
    // ]);
    // The status code may not be available directly on the response object returned by deleteExtraLora.
    // Instead, check for res?.data?.success or res?.error, or inspect the structure of the response.
    // Here's a safer way to handle it:

    const res = await deleteExtraLora({ name, sure: false });
    if (res && res.error && res.error.status === 400) {
      console.log(res.error.data.data);
      setDeleteLoraName(name);
      setloraExistsInfo(res.error.data.data);
      setShowDeleteConfirm(true);
    } else {
      setrows((prevRows) => prevRows.filter((r) => r.name !== name));
      Object.keys(loadedPrompt.extraLoras).forEach((key) => {
        dispatch(
          setLoadedPrompt({
            key: ["extraLoras", key],
            data: loadedPrompt.extraLoras[key].filter(
              (item) => item.name !== name
            ),
          })
        );
      });
      setToast({
        show: true,
        severity: "success",
        msg: "Lora removed",
      });
    }
  };
  const handleDeleteLora = (name) => {
    dispatch(
      setLoadedPrompt({
        key: ["extraLoras", `${loadedPrompt.species}_${loadedPrompt.gender}`],
        data: [
          ...loadedPrompt.extraLoras[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ].filter((item) => item.name !== name),
        ],
      })
    );
  };

  useEffect(() => {
    if (deleteConfirmData) {
      const res = deleteExtraLora({ name: deleteLoraName, sure: true });

      setToast({
        show: true,
        severity: "success",
        msg: "Lora removed",
      });
      setrows((prevRows) => prevRows.filter((r) => r.name !== deleteLoraName));
      setDeleteConfirmData(false);
      setShowDeleteConfirm(false);
      setDeleteLoraNameConfirm("");
      setDeleteLoraName("xsdxcxfcdfsddsx");
      setloraExistsInfo(false);
      Object.keys(loadedPrompt.extraLoras).forEach((key) => {
        dispatch(
          setLoadedPrompt({
            key: ["extraLoras", key],
            data: loadedPrompt.extraLoras[key].filter(
              (item) => item.name !== deleteLoraName
            ),
          })
        );
      });
    }
  }, [deleteConfirmData]);

  useEffect(() => {
    if (copyAcrossDialogData) {
      // console.log(
      //   loadedPrompt.extraLoras[
      //     `${loadedPrompt.species}_${loadedPrompt.gender}`
      //   ]
      // );
      selectedSpeciesGenders.forEach((item) => {
        if (item.checked) {
          dispatch(
            setLoadedPrompt({
              key: ["extraLoras", item.value],
              data: [
                ...loadedPrompt.extraLoras[item.value],
                ...loadedPrompt.extraLoras[
                  `${loadedPrompt.species}_${loadedPrompt.gender}`
                ],
              ],
            })
          );
          const triggerWords = loadedPrompt.extraLoras[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ]
            .map((item) => item.trigger_words)
            .join(", ");
          dispatch(
            setLoadedPrompt({
              key: ["prompts", item.value],
              data: triggerWords + "\n\n" + loadedPrompt.prompts[item.value],
            })
          );
        }
      });
    }
  }, [copyAcrossDialogData]);

  const handleChangeExtraStrength = (index, value) => {
    dispatch(
      setLoadedPrompt({
        key: ["extraLoras", `${loadedPrompt.species}_${loadedPrompt.gender}`],
        data: [
          ...loadedPrompt.extraLoras[
            `${loadedPrompt.species}_${loadedPrompt.gender}`
          ].map((item, idx) => {
            if (index === idx) {
              var t = { ...item, strength: value };
              return t;
            } else {
              return item;
            }
          }),
        ],
      })
    );
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const getRowHeight = (params) => {
    const lineHeight = 20;
    const lines = Math.ceil(params.model.description.length / 50);
    const minHeight = 100;
    const maxHeight = 200; // or whatever makes sense for your UI
    const calculatedHeight = lines * lineHeight + 16;
    return Math.max(minHeight, Math.min(calculatedHeight, maxHeight));
  };

  const columns = [
    { field: "name", headerName: "name", width: 250 },

    {
      field: "image_url",
      headerName: "image",
      width: 100,
      editable: false,
      headerAlign: "center",
      // renderCell: (params) => {
      //   return (
      //     <img
      //       src={params.row.image_url}
      //       alt="thumbnail"
      //       width={100}
      //       height={100}
      //     />
      //   );
      // },
    },
    {
      field: "rate",
      headerName: "rate",
      width: 200,
      editable: false,
      headerAlign: "center",
    },
    {
      field: "description",
      headerName: "description",
      width: 700,
      editable: false,
    },
    {
      field: "actions",
      headerName: "actions",
      width: 160,
      editable: false,
      headerAlign: "center",
    },
  ];

  const onClose = () => {
    setToast({ ...toast, show: false });
  };
  function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
  }

  useEffect(() => {
    if (addNewLoraDialogData) {
      setDownloadingNewLora(true);
      handleAddNewExtraLora();
    }
  }, [addNewLoraDialogData]);

  const handleAddNewExtraLora = async () => {
    const res = await addExtraLora({
      name: newLoraNameRef.current.value,
      id: newLoraIdRef.current.value,
      description: newLoraDescriptionRef.current.value,
    }).unwrap();
    const data = res.data;
    console.log(data);
    setrows((prevRows) => [...prevRows, data]);
    setToast({
      ...toast,
      show: true,
      severity: "success",
      msg: "Lora added",
    });
    setDownloadingNewLora(false);
    setAddNewLoraDialogOpen(false);
    setAddNewLoraDialogData(false);
  };

  useEffect(() => {
    if (toast.show) {
      setTimeout(() => {
        setToast({ ...toast, show: false });
      }, 1000);
    }
  }, [toast]);

  const updateRow = (row, key, value) => {
    setrows((prevRows) =>
      prevRows.map((r) => (r.name === row.name ? { ...r, [key]: value } : r))
    );
  };

  if (isLoading || rows.length === 0) return <div>Loading...</div>;
  if (error) return <div>Error: {error.toString()}</div>;

  return (
    <>
      <MediumDialog
        title="Extra LORAs"
        content=""
        open={extraDialogOpen}
        setOpen={setextraDialogOpen}
        setData={setextraDialogData}
        confirmButton="save"
        cancelButton="cancel"
        blocked={false}
      >
        <FlexColumn>
          <FlexRow>
            {/* <TextField
            margin="normal"
            id="extralora"
            label="extra lora name"
            name="extralora"
            value={extraloraname}
            onChange={(e) => setextraloraname(e.target.value)}
            className="ring-0"
            sx={{ width: "330px" }}
            size="small"
            onKeyDown={(e) => e.stopPropagation()}
          />
          <Button
            variant="contained"
            sx={{ marginTop: "7px" }}
            onClick={handleAddExtraLora}
          >
            ADD
          </Button> */}
            <Button
              variant="contained"
              sx={{ marginTop: "7px" }}
              onClick={handleOpenDialog}
            >
              VIEW LIST
            </Button>
            <Button
              variant="contained"
              sx={{ marginTop: "7px" }}
              onClick={() => setCopyAcrossDialogOpen(true)}
            >
              COPY ACROSS SPECIES & GENDER
            </Button>
          </FlexRow>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="flex-start"
            width="100% "
            marginTop="20px"
          >
            {loadedPrompt.extraLoras[
              `${loadedPrompt.species}_${loadedPrompt.gender}`
            ] &&
              loadedPrompt.extraLoras[
                `${loadedPrompt.species}_${loadedPrompt.gender}`
              ].map((item, index) => {
                return (
                  <>
                    <Box
                      display="flex"
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100% "
                      borderBottom="1px solid rgb(194, 194, 193)"
                      borderTop={index === 0 && "1px solid rgb(194, 194, 193)"}
                    >
                      <Typography sx={{ width: "80%" }}>{item.name}</Typography>
                      <TextField
                        type="number"
                        min={0}
                        step={0.1}
                        margin="normal"
                        id="extraLoraStrength"
                        label="strength"
                        name="strength"
                        value={
                          loadedPrompt.extraLoras[
                            `${loadedPrompt.species}_${loadedPrompt.gender}`
                          ][index].strength
                        }
                        onChange={(e) =>
                          handleChangeExtraStrength(index, e.target.value)
                        }
                        className="ring-0"
                        sx={{ width: "70px" }}
                        size="small"
                        onKeyDown={(e) => e.stopPropagation()}
                      />
                      <Button
                        variant="contained"
                        sx={{ marginTop: "7px" }}
                        onClick={() => handleDeleteLora(item.name)}
                      >
                        REMOVE
                      </Button>
                    </Box>
                  </>
                );
              })}
          </Box>
        </FlexColumn>
        <SmallDialog
          open={copyAcrossDialogOpen}
          setOpen={setCopyAcrossDialogOpen}
          setData={setCopyAcrossDialogData}
          title="Copy extra loras data"
          content="Copy extra loras data across species & gender. Select the species and gender you want to copy the data to."
          confirmButton="COPY"
          cancelButton="cancel"
        >
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FormGroup>
              {selectedSpeciesGenders
                .filter(
                  (item) =>
                    item.value !==
                    `${loadedPrompt.species}_${loadedPrompt.gender}`
                )
                .map((item) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={item.checked}
                        onChange={(e) =>
                          setSelectedSpeciesGenders((current) =>
                            current.map((itm) =>
                              itm.value === item.value
                                ? { ...itm, checked: e.target.checked }
                                : itm
                            )
                          )
                        }
                        sx={{
                          color: "#FFD600",
                          "&.Mui-checked": {
                            color: "#FFD600",
                          },
                        }}
                      />
                    }
                    label={item.label}
                  />
                ))}
            </FormGroup>
          </Box>
        </SmallDialog>
      </MediumDialog>

      <MediumDialog
        title="Available extra losras"
        content=""
        open={dialogOpen}
        setOpen={setDialogOpen}
        setData={setDialogData}
        confirmButton=""
        cancelButton=""
        blocked={false}
        maxwidth="xl"
      >
        <Toast alert={toast} setAlert={setToast}></Toast>
        <Box width="100%" sx={{ maxHeight: "90vh", position: "relative" }}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            marginBottom="10px"
            marginTop="10px"
            onClick={() => setAddNewLoraDialogOpen(true)}
          >
            <Button variant="contained">ADD NEW LORA</Button>
          </Box>
          <DataGrid
            rows={rows}
            getRowId={(row) => row.name}
            columns={columns}
            slots={{
              row: Row,
              toolbar: GridToolbar,
            }}
            slotProps={{
              row: {
                handleAddExtraLora: handleAddExtraLora,
                updateRow: updateRow,
                handleRemoveExtraLora: handleRemoveExtraLora,
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 100,
                },
              },
            }}
            pageSizeOptions={[50]}
            disableRowSelectionOnClick
            getRowHeight={getRowHeight}
          />
        </Box>
      </MediumDialog>
      <SmallDialog
        open={showDeleteConfirm}
        setOpen={setShowDeleteConfirm}
        setData={setDeleteConfirmData}
        title="Delete extra lora"
        content={
          <div>
            Are you sure you want to delete{" "}
            <span style={{ color: "rgb(255, 255, 255)", fontWeight: "bold" }}>
              {deleteLoraName}
            </span>{" "}
            extra lora?
          </div>
        }
        confirmButton="delete"
        cancelButton="cancel"
        blocked={deleteLoraNameConfirm !== deleteLoraName}
      >
        {loraExistsInfo && (
          <>
            <Typography
              sx={{ marginTop: "20px" }}
            >{`Lora is currently used in ${loraExistsInfo.length} ${
              loraExistsInfo.length > 1 ? "prompts" : "prompt"
            }\n\n`}</Typography>

            {loraExistsInfo.prompts.map((prompt) => (
              <Box display="flex" flexDirection="row" gap="10px">
                <Typography>{`- ${prompt.category}`}</Typography>
                <Typography>{`${prompt.product}`}</Typography>
                <Typography
                  sx={{ fontWeight: "bold", color: "rgb(233, 210, 6)" }}
                >{`${prompt.name}`}</Typography>
              </Box>
            ))}
            <TextField
              value={deleteLoraNameConfirm}
              onChange={(e) => setDeleteLoraNameConfirm(e.target.value)}
              sx={{ width: "100%", marginTop: "20px" }}
              placeholder="Type the name of the lora to delete"
            />
          </>
        )}
      </SmallDialog>
      <SmallDialog
        open={addNewLoraDialogOpen}
        setOpen={setAddNewLoraDialogOpen}
        setData={setAddNewLoraDialogData}
        title="Add new lora"
        content=""
        confirmButton="ADD"
        cancelButton="cancel"
        maxwidth="md"
        closeOnConfirm={false}
        blocked={downloadingNewLora}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {downloadingNewLora ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap="20px"
            >
              <CircularProgress
                sx={{ marginBottom: "20px", color: "rgb(233, 210, 6)" }}
              />
              <Typography sx={{ marginBottom: "20px" }}>
                Downloading new lora...
              </Typography>
            </Box>
          ) : (
            <>
              <Typography sx={{ alignSelf: "flex-start" }}>
                Enter the CIVITAI URL of the lora you want to add.
              </Typography>

              <Box
                display="flex"
                flexDirection="column"
                gap="10px"
                marginTop="20px"
                width="400px"
                alignItems="center"
                justifyContent="center"
              >
                <TextField
                  size="small"
                  className="ring-0"
                  label="CIVITAI URL"
                  inputRef={newLoraIdRef}
                  sx={{
                    width: "100%",
                    "& label": { color: "#fff" },
                    "& label.Mui-focused": { color: "#fff" },
                  }}
                />
                <TextField
                  size="small"
                  className="ring-0"
                  label="NAME"
                  inputRef={newLoraNameRef}
                  sx={{
                    width: "100%",
                    "& label": { color: "#fff" },
                    "& label.Mui-focused": { color: "#fff" },
                  }}
                />
                <TextField
                  size="small"
                  className="ring-0"
                  label="DESCRIPTION"
                  inputRef={newLoraDescriptionRef}
                  multiline
                  sx={{
                    width: "100%",
                    "& label": { color: "#fff" },
                    "& label.Mui-focused": { color: "#fff" },
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      </SmallDialog>
    </>
  );
};

export default ExtraLoraDialog;

const Row = (props) => {
  const [updateExtraLoraRate] = useRateExtraLoraMutation();
  const handleUpdateRate = (name, value) => {
    updateExtraLoraRate({ name, rate: value });
    props.updateRow(props.row, "rate", value);
  };
  const [rate, setRate] = useState(props.row.rate);
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [noteDialogData, setNoteDialogData] = useState("");
  const [note, setNote] = useState("");
  const [expandNotes, setExpandNotes] = useState(false);
  const [addNote] = useExtraLoraNotesMutation();
  useEffect(() => {
    if (noteDialogData) {
      console.log(props.row.notes);
      var notes = [...props.row.notes, note];
      addNote({ name: props.row.name, notes: notes });
      props.updateRow(props.row, "notes", notes);
    }
  }, [noteDialogData]);

  const handleCopyTriggerWords = () => {
    navigator.clipboard.writeText(props.row.trigger_words.join(", "));
  };

  return (
    <>
      <TableRow key={props.row.name + props.row.id}>
        <TableCell
          component="th"
          scope="row"
          style={{ width: 250 }}
          onClick={() => {
            window.open(props.row.url, "blank");
          }}
          sx={{ cursor: props.row.url ? "pointer" : "default" }}
        >
          {props.row.name}
        </TableCell>
        <TableCell style={{ width: 100 }} align="center">
          <img
            src={props.row.image_url}
            alt="thumbnail"
            width={80}
            height="auto"
          />
        </TableCell>
        <TableCell style={{ width: 200 }} align="center">
          <Rating
            value={rate}
            onChange={(event, newValue) => {
              setRate(newValue);
              handleUpdateRate(props.row.name, newValue);
            }}
          />
        </TableCell>

        {/* <TableCell style={{ width: 100 }} align="center">
          {'gender' in rowx ? rowx.gender : 'male'}
        </TableCell> */}
        <TableCell style={{ width: 700 }} align="left">
          {props.row.description}
        </TableCell>

        <TableCell style={{ width: 160 }} align="center">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                props.handleAddExtraLora({
                  name: props.row.name,
                  strength: props.row.strength,
                  trigger_words: props.row.trigger_words,
                });
              }}
            >
              ADD
            </Button>
            {/* <Button
              variant="contained"
              size="small"
              onClick={() => {
                setNoteDialogOpen(true);
              }}
            >
              NOTE
            </Button> */}
            <ExtraLoraEditMenu
              showNoteDialog={setNoteDialogOpen}
              copyTriggerWords={handleCopyTriggerWords}
              removeLora={() => props.handleRemoveExtraLora(props.row.name)}
            />
            {props.row.notes && props.row.notes.length > 0 && (
              <IconButton>
                <ExpandMore
                  onClick={() => setExpandNotes((current) => !current)}
                  sx={{
                    transform: expandNotes ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </IconButton>
              // <TableRow>
              //   <TableCell
              //     colSpan={7}
              //     style={{ background: "#000", borderTop: "none" }}
              //   >
              //     <Box sx={{ p: 2 }}>
              //       <Typography variant="subtitle2" color="textSecondary">
              //         Notes:
              //       </Typography>
              //       <Typography variant="body2" color="textPrimary">
              //         {props.row.notes}
              //       </Typography>
              //     </Box>
              //   </TableCell>
              // </TableRow>
            )}
          </Box>
        </TableCell>
        {expandNotes && (
          <Box
            sx={{
              background: "rgba(0, 0, 0, 0.5)",
              borderTop: "none",
              padding: "10px",
            }}
          >
            {props.row.notes
              .slice()
              .reverse()
              .map((note, index) => (
                <Typography key={index}>{`- ${note}`}</Typography>
              ))}
          </Box>
        )}
        {/* Expandable row for notes */}
      </TableRow>
      <SmallDialog
        open={noteDialogOpen}
        setOpen={setNoteDialogOpen}
        setData={setNoteDialogData}
        title="Add note"
        content=""
        confirmButton="save"
        cancelButton="cancel"
        maxwidth="md"
      >
        <TextField
          value={note}
          onChange={(e) => setNote(e.target.value)}
          multiline
          rows={4}
          sx={{ width: "500px" }}
        />
      </SmallDialog>
    </>
  );
};
